import { generateTestId } from "@client-shared";

export const setLabelsViewTestId = (identifier: string): string => generateTestId("LabelsView", identifier);

export const setLabelsViewPrintQueueButtonTestId = (): string => setLabelsViewTestId("print-queue-button");

export const setLabelsViewNewLabelButtonTestId = (): string => setLabelsViewTestId("new-label-button");
